import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo, services } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={companyInfo.logoDark}
              alt={companyInfo.name}
              className="h-12 w-auto mb-6"
            />
            <p className="text-white/60 body-small mb-6">
              {companyInfo.tagline}
            </p>
            <div className="space-y-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 text-white/60 hover:text-cyan-400 transition-colors text-sm"
              >
                <Phone size={14} />
                <span>{companyInfo.phone}</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-white/60 hover:text-cyan-400 transition-colors text-sm"
              >
                <Mail size={14} />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-center gap-2 text-white/60 text-sm">
                <MapPin size={14} />
                <span>{companyInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-mono text-sm tracking-wider mb-6">SERVICES</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-white/60 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-white font-mono text-sm tracking-wider mb-6">QUICK LINKS</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/60 hover:text-cyan-400 transition-colors text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#work" className="text-white/60 hover:text-cyan-400 transition-colors text-sm">
                  Our Work
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-white/60 hover:text-cyan-400 transition-colors text-sm">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/60 hover:text-cyan-400 transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-white font-mono text-sm tracking-wider mb-6">GET STARTED</h4>
            <p className="text-white/60 text-sm mb-6">
              Ready to grow your business? Let&apos;s talk about your project.
            </p>
            <a
              href="#contact"
              className="cta-button bg-cyan-500 text-black border-cyan-500 hover:bg-cyan-400 inline-block"
            >
              Free Consultation
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
